import React from 'react'
import { Icon } from '@iconify/react'
import { Typography } from 'antd'

import styles from './ClientsEmptyState.module.css'

const { Text } = Typography

const ClientsEmptyState = ({ search = '' }) => {
    const hasSearch = Boolean(String(search || '').trim())

    return (
        <div className={styles.emptyState}>
            <div className={styles.emptyCard}>
                <div className={styles.emptyIconWrap}>
                    <Icon
                        icon={
                            hasSearch
                                ? 'mdi:magnify'
                                : 'mdi:account-group-outline'
                        }
                        className={styles.emptyIcon}
                    />
                </div>
                <Text className={styles.emptyTitle}>
                    {hasSearch ? 'No matching clients' : 'No clients found'}
                </Text>
                <Text className={styles.emptyText}>
                    {hasSearch
                        ? `We couldn't find any clients matching "${String(search).trim()}". Try a different name or email.`
                        : 'Create your first client to start organizing work, assignments, and project collaborations.'}
                </Text>
            </div>
        </div>
    )
}

export default ClientsEmptyState
